import React, {useCallback, useState} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {createAndSub} from './api/CreateAndSub';
import {SubscriptionForm} from './Components/SubscriptionForm';
import {GetCurrentSubscriptionCode} from './hooks/hooks';
import {SignupTabs} from './Utility/constants';

function SignUp(props) {
  const trialData = useSelector(state => state?.app.trialData);
  const keyData = useSelector(state => state?.app?.keyData);
  const payluxData = useSelector(state => state?.app?.payluxData);
  const [activeTab, setActiveTab] = useState(0);
  const [errorMsg, setErrorMsg] = useState(null);
  const [trial, setAccountTrial] = useState(false);
  const [isCCValid, setCCValid] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    firstname: '',
    lastname: '',
    cc: '',
    expiryMM: '',
    expiryYY: '',
    cvv: '',
    address1: '',
    address2: '',
    country: '',
    zip: '',
    state: '',
    city: '',
    key: '',
  });

  const navigate = useNavigate();

  const handleSubmit = useCallback(
    e => {
      e.preventDefault();
      //User clicks SignUp
      //let isCC = require('luhn').validate(formData?.cc);
      //setCCValid(isCC);
      if (formData?.email && formData?.password /* && isCC */) {
        //use an HTTP call and not Accounts NPM package. REASON: AccountsNPM returns JSX, we need validation
        let subscriptionCode = GetCurrentSubscriptionCode(
          SignupTabs[activeTab],
          trialData,
          payluxData,
          keyData,
        );
        createAndSub(subscriptionCode, formData, activeTab, setErrorMsg, navigate);
      } else {
        console.log('form not valid');
      }
    },
    [formData],
  );

  const handleResetSubscriptionFields = useCallback(() => {
    //console.log('called');
    setFormData({
      ...formData,
      firstname: '',
      lastname: '',
      cc: '',
      expiryMM: '',
      expiryYY: '',
      cvv: '',
      address1: '',
      address2: '',
      country: '',
      city: '',
      zip: '',
      state: '',
    });
  }, [formData]);

  const handleTrialChange = useCallback(() => {
    setAccountTrial(!trial);
  }, [trial]);

  const handleNavToAuth = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const handleRadioChange = useCallback(
    radioBtnNum => {
      setActiveTab(radioBtnNum);

      switch (radioBtnNum) {
        case 0:
          handleResetSubscriptionFields();
          setFormData({...formData, key: ''});
          setAccountTrial(false);
          break;
        case 1:
          setFormData({...formData, key: ''});
          setAccountTrial(false);
          break;
        case 2:
          setFormData({...formData, key: ''});
          handleResetSubscriptionFields();
          break;
      }
    },
    [formData],
  );

  const handleFormChange = useCallback(
    event => {
      const {target} = event;
      const {name, value} = target;
      setErrorMsg(null);
      setFormData({...formData, [name]: value});
    },
    [formData],
  );

  //intentionally not put callback as it resets the form
  const handleValidation1000 = e => {
    const {target} = e;
    const {name, value} = target;
    if (value < 1000) {
      setFormData({...formData, [name]: value});
    } else {
      console.log('ignored');
    }
  };

  const handleValidation100 = e => {
    const {target} = e;
    const {value} = target;
    if (value < 100) {
      handleFormChange(e);
    } else {
      console.log('ignored');
    }
  };

  return (
    <div className="Auth-form-container">
      <form className="Auth-form" onSubmit={handleSubmit} autoComplete="off">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Sign Up</h3>
          <div className="form-group mt-3">
            <label>Email address</label>
            <input
              value={formData?.email}
              onChange={handleFormChange}
              name="email"
              id="email"
              type="email"
              className="form-control mt-1"
              placeholder="Enter email"
              required
            />
          </div>
          <div className="form-group mt-3">
            <label>Password</label>
            <input
              value={formData?.password}
              onChange={handleFormChange}
              name="password"
              id="password"
              type="password"
              className={!errorMsg ? 'form-control mt-1' : 'form-control mt-1 is-invalid'}
              placeholder="Enter password"
              required
            />
            <div className="invalid-feedback">{errorMsg}</div>
          </div>
          <div className="form-group mt-3">
            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={activeTab === 0 ? 'nav-link active' : 'nav-link'}
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="false"
                  onClick={() => handleRadioChange(0)}
                >
                  Key
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={activeTab === 1 ? 'nav-link active' : 'nav-link'}
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="true"
                  onClick={() => handleRadioChange(1)}
                >
                  Subscribe
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={activeTab === 2 ? 'nav-link active' : 'nav-link'}
                  id="pills-trial-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-trial"
                  type="button"
                  role="tab"
                  aria-controls="pills-trial"
                  aria-selected="true"
                  onClick={() => handleRadioChange(2)}
                >
                  Trial
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className={activeTab === 0 ? 'tab-pane fade show active' : 'tab-pane fade'}
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <label>Key</label>
                <textarea
                  value={formData?.key}
                  onChange={handleFormChange}
                  name="key"
                  id="key"
                  type="text"
                  className="form-control mt-1"
                  placeholder="Enter key from vendor"
                  style={{resize: 'none'}}
                  rows={3}
                />
              </div>
              <div
                className={activeTab === 1 ? 'tab-pane fade show active' : 'tab-pane fade'}
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
              >
                <SubscriptionForm
                  formData={formData}
                  isCCValid={isCCValid}
                  handleFormChange={handleFormChange}
                  handleValidation100={handleValidation100}
                  handleValidation1000={handleValidation1000}
                />
              </div>
              <div
                className={activeTab === 2 ? 'tab-pane fade show active' : 'tab-pane fade'}
                id="pills-trial"
                role="tabpanel"
                aria-labelledby="pills-trial-tab"
              >
                <div className="form-check">
                  <input
                    //value={formData?.trail}
                    onChange={handleTrialChange}
                    name="trial"
                    id="trial"
                    type="checkbox"
                    className="form-check-input mt-1"
                    checked={trial ? true : false}
                    required={activeTab === 2 ? true : false}
                  />
                  <label className="form-check-label" htmlFor="trial">
                    Trial for {`${trialData?.TrialLength} ${trialData?.Period} `}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="d-grid gap-2 mt-3">
            <button type="submit" className="btn btn-primary">
              Sign Up
            </button>
          </div>
          <div className="d-grid gap-2 mt-2">
            <button type="submit" className="btn btn-primary" onClick={handleNavToAuth}>
              Sign In
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default SignUp;
